<template>
  <div class="w-100 CARD">
    <div v-if ="$device.isMobile" class="d-flex">
      <div class="d-flex fd-column w-100 p-l-2:t">
        <div class="HEADER d-flex fd-column  jc-start p-b-2">
          <div class="TITLE">{{ content.title }}</div>
          <div class="DATE">{{convertDate(content.date)}}</div>
        </div>
        <div class="d-flex">
          <div v-if="hasIcon">
            <img class="ICON ai-start" :src="content.icon"/>
          </div>
          <div v-html="content.content" class="CONTENT p-b-2"></div>
        </div>
        <div v-if="hasImages" class="p-b-2 d-flex">
          <img
              v-for="(image, index) in content.images"
              class="IMAGE"
              @click="openImageModal(image.url)"
              :key="index"
              :src="image.url">
        </div>
        <div v-if="hasButton" class="m-b-2">
          <button
              @click="buttonClicked"
              class="btn-secondary BUTTON">
            {{content.buttonCta}}
          </button>
        </div>
      </div>
    </div>
    <div v-else class="d-flex">
      <div v-if="hasIcon" >
        <img class="ICON m-r-2" :src="content.icon"/>
      </div>
      <div class="d-flex fd-column w-100">
        <div class="HEADER d-flex jc-between p-b-2">
          <div class="TITLE">{{ content.title }}</div>
          <div class="DATE">{{convertDate(content.date)}}</div>
        </div>
        <div v-html="content.content" class="CONTENT p-b-2"></div>
        <div v-if="hasImages" class="IMAGES p-b-2 d-flex">
          <div v-if="hasImages" class="IMAGES p-b-2 d-flex">
            <img
                v-for="(image, index) in content.images"
                class="IMAGE"
                @click="openImageModal(image.url)"
                :key="index"
                :src="image.url">
          </div>
        </div>
        <div v-if="hasButton" class="m-b-2">
          <button
              @click="buttonClicked"
              class="btn-secondary BUTTON">
            {{content.buttonCta}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';

export default {
  name: 'whats-new-item',

  props: {
    openImageModal: {
      type: Function,
    },
    content: {
      type: Object,
      required: true,
      validator (content) {
        const requiredKeys = ['title', 'content', 'date'];
        return requiredKeys.every(key => Object.keys(content).includes(key));
      },
    },
  },
  computed: {
    hasImages () {
      return this.content.images;
    },
    hasIcon () {
      return this.content.icon;
    },
    hasButton () {
      return this.content.buttonCta && this.content.buttonUrl;
    },
  },
  methods: {
    buttonClicked () {
      this.$events.$emit(this.$events.WHATS_NEW_BUTTON_CLICK,
        {
          CTA: this.content.buttonCta,
          URL: this.content.buttonUrl,
        });
      window.open(this.content.buttonUrl, '_blank');
    },
    convertDate (date) {
      return format(new Date(date), 'MMMM dd yyyy');
    },
    close () {
      this.isOpen = false;
      this.currentImage = '';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .CARD {
     @include mobile-only(){
       max-width: 100vw;
     };
    padding: $unit * 2.5;
    background-color: white;
    border: 1px solid $color-gray40;
  }
  .TITLE {
    @include h5;
    font-weight: bold;
  }
  .CONTENT {
    color: $color-gray70;
  }
  .DATE {
    text-align: right;
    @include mobile-only() {
      text-align: left;
    }
  }
  .ICON {
    margin: 32px 4px;
    @include square(80px);
    @include mobile-only () {
      @include square(40px);
      margin: 0px 10px 0px 0px;
    }
  }
  .BUTTON {
    width: auto;
    @include mobile-only () {
      width: 100%;
    }
  }
  .IMAGE {
    max-width: 270px;
    padding-right: 2 * $unit;
    align-self: center;
   &:last-child {
     padding-right: 0px;
    }
    @include mobile-only (){
      max-width: 98px;
    }
    @include tablet-only (){
      max-width: 150px;
    }
  }
</style>
